class ProductCustomSiblings extends HTMLElement {
    constructor() {
        super();

        this.selectors = {
            buttonsDogSize: '.product-custom-siblings__dog-size-option-wrapper',
            price: '.product-section .amount.main-price',
            resultPricePerDayWrapper: '.product-custom-siblings__price-per-day',
            buyMultipleQuantity: '.product-custom-siblings__option-wrapper',
            frequencyInputs: '.product-frequencies__option-wrapper input',
            productForm: 'product-form',
            productAddToCartId: '#AddToCart',
            buttonsDogSizeOptions: ".product-custom-siblings__options"
        }

        this.enableExtraFunctionality = this.hasAttribute("data-show-dog-size-options") && this.getAttribute("data-show-dog-size-options") === "true";
        this.dogWeight = parseFloat(localStorage.getItem('selectedDogWeight')) || null;
        this.closestProductForm = this.closest(this.selectors.productForm);
        this.productData = undefined;

        // Disable if UI not ready
        if (!this.closestProductForm) {
            this.enableExtraFunctionality = false;
            console.log('Extra functionality disabled - product form not found');
        }

        // Verify dog size options actually exist in DOM
        if (this.enableExtraFunctionality) {
            const hasDogSizeOptions = this.querySelectorAll(this.selectors.buttonsDogSize).length > 0;
            if (!hasDogSizeOptions) {
                this.enableExtraFunctionality = false;
            }
        }

        // Always ensure button is not disabled initially
        this.productAddToCartButton = document.querySelector(this.selectors.productAddToCartId);
        if (this.productAddToCartButton) {
            if (this.enableExtraFunctionality) {
                this.productAddToCartButton.classList.add("loading", "pe-none");
            } else {
                this.productAddToCartButton.classList.remove("loading", "pe-none");
            }
        }

        if (this.enableExtraFunctionality) {
            if (Object.keys(this.closestProductForm.productData).length > 0) {
                this.initFunctions();
            } else {
                this.closestProductForm.addEventListener('product-data-retrieved', () => {
                    this.initFunctions();
                });
            }
        } else {
            console.log('No extra functionality');
            if (this.productAddToCartButton) {
                this.productAddToCartButton.classList.remove("loading", "pe-none");
            }
            this.slideDown();
        }
    }

    initFunctions() {
        this.productData = this.closestProductForm.productData;

        if (window.store.enableConvertABTest) {
            this.setupEventListeners();
            this.initializeActiveButton();
            this.calculatePricePerQuantity();
            this.slideDown();
        } else {
            if (this.querySelector(this.selectors.buttonsDogSizeOptions)) {
                this.querySelector(this.selectors.buttonsDogSizeOptions).classList.remove("product-custom-siblings__options--with-dog-size")
                this.removeAttribute("data-show-dog-size-options");
                this.productAddToCartButton = document.querySelector(this.selectors.productAddToCartId);
                this.productAddToCartButton ? this.productAddToCartButton.classList.remove("loading", "pe-none") : null;
                this.slideDown();
            }
        }
    }

    showSkeleton() {
        // Show skeleton loader in price displays
        const priceWrappers = document.querySelectorAll(this.selectors.resultPricePerDayWrapper);
        priceWrappers.forEach(wrapper => {
            if (wrapper.textContent.trim() !== '') {
                const currentText = wrapper.textContent;
                wrapper.innerHTML = `<div class="skeleton-loader" style="background-color: #ebeee3; border-radius: 4px; height: 1em; width: ${currentText.length * 0.6}em; display: inline-block;"></div>`;
            }
        });
    }

    setupEventListeners() {
        this.elements = {
            buttonsDogSize: this.querySelectorAll(this.selectors.buttonsDogSize),
            buyMultipleQuantity: document.querySelector(this.selectors.buyMultipleQuantity),
            frequencyInputs: document.querySelectorAll(this.selectors.frequencyInputs),
        }

        this.classes = {
            activeButton: 'product-custom-siblings__dog-size-option-wrapper--active',
        }

        this.productAddToCartButton ? this.productAddToCartButton.classList.remove("loading", "pe-none") : null;

        this.elements.buttonsDogSize.forEach(button => {
            button.addEventListener('click', () => {
                this.clearActiveButtons();
                button.classList.add(this.classes.activeButton);

                // Show skeleton if prices exist
                this.showSkeleton();

                const input = button.querySelector('input');
                const startWeight = parseFloat(input.dataset.start);
                const endWeight = parseFloat(input.dataset.end);

                // Store the middle of the range as the selected weight
                const middleWeight = (startWeight + endWeight) / 2;
                this.dogWeight = middleWeight;
                localStorage.setItem('selectedDogWeight', middleWeight.toString());
                this.selectedDogWeightButton = button;

                // Calculate prices after a small delay for skeleton effect
                setTimeout(() => {
                    this.calculatePricePerQuantity();
                }, 300);
            });
        });

        this.elements.frequencyInputs.forEach(input => {
            input.addEventListener('change', () => {
                this.calculatePricePerQuantity(this.elements.buttonsDogSize[0]);
            });
        });
    }

    clearActiveButtons() {
        this.elements.buttonsDogSize.forEach(button => {
            button.classList.remove(this.classes.activeButton);
        });
    }

    calculatePricePerQuantity() {
        // Get product price from price element
        this.price = document.querySelector(this.selectors.price);
        const productPrice = this.productData.variants[0].price / 100;


        // Get number of days the product lasts
        const daysString = this.dataset.numberOfDays || '';
        this.numberOfDays = parseInt(daysString.match(/\d+/)?.[0]) || 0;

        // Get the dosage fraction from selected dog weight button
        const dosageFraction = parseFloat(this.selectedDogWeightButton.querySelector('input').value);


        // Calculate how many days this dosage will last
        const daysPerProduct = this.numberOfDays / dosageFraction;
        const recurrentDiscount = document.querySelector('.product-frequencies__option-wrapper input[value="recurrent"]')?.checked ? 5 : 0;

        console.log(recurrentDiscount);
        // Calculate price per day
        const pricePerDay = productPrice / daysPerProduct;

        console.log(`Days per product at this dosage: ${daysPerProduct}, Price per day: €${pricePerDay.toFixed(2)}`);

        // Update price for each quantity option
        document.querySelectorAll(this.selectors.buyMultipleQuantity).forEach(buyMultipleQuantity => {

            const input = buyMultipleQuantity.querySelector('input');

            if (input) {
                const quantity = parseInt(input.value);
                const discount = parseFloat(input.dataset.discount) || 0;

                const totalPricePerDay = pricePerDay * (1 - discount / 100) * (1 - recurrentDiscount / 100);

                // Find the price wrapper for this specific input
                const priceWrapper = buyMultipleQuantity?.querySelector(this.selectors.resultPricePerDayWrapper);

                if (priceWrapper) {
                    // Truncate to 2 decimals (not round)
                    const truncatedPrice = Math.floor(totalPricePerDay * 100) / 100;
                    priceWrapper.innerHTML = `$${truncatedPrice.toFixed(2)} CAD / day`;
                }
            }

        });
    }

    initializeActiveButton() {
        let buttonToActivate = null;

        if (!this.dogWeight) {
            // No localStorage value, select first button
            buttonToActivate = this.elements.buttonsDogSize[0];
        } else {
            // Find the best matching weight range
            buttonToActivate = this.findClosestWeightRangeButton(this.dogWeight);

            // Fallback to first button if nothing found
            if (!buttonToActivate) {
                buttonToActivate = this.elements.buttonsDogSize[0];
            }
        }

        if (buttonToActivate) {
            buttonToActivate.classList.add(this.classes.activeButton);
            buttonToActivate.querySelector('input').checked = true;
        }
        this.selectedDogWeightButton = buttonToActivate;
    }

    findClosestWeightRangeButton(targetWeight) {
        let bestButton = null;
        let bestScore = Infinity;

        this.elements.buttonsDogSize.forEach(button => {
            const input = button.querySelector('input');
            const startWeight = parseFloat(input.dataset.start);
            const endWeight = parseFloat(input.dataset.end);

            // Check if weight falls within this range
            if (targetWeight >= startWeight && targetWeight <= endWeight) {
                // Perfect match - weight is in range, prefer closest to start
                const distanceFromStart = Math.abs(targetWeight - startWeight);
                if (distanceFromStart < bestScore) {
                    bestScore = distanceFromStart;
                    bestButton = button;
                }
            } else {
                // Weight is outside range, calculate minimum distance to range
                let distanceToRange;
                if (targetWeight < startWeight) {
                    distanceToRange = startWeight - targetWeight;
                } else {
                    distanceToRange = targetWeight - endWeight;
                }

                // Add penalty for being outside range + distance to start
                const penalty = 1000; // Large penalty for being outside range
                const distanceFromStart = Math.abs(targetWeight - startWeight);
                const score = penalty + distanceToRange + distanceFromStart;

                if (score < bestScore) {
                    bestScore = score;
                    bestButton = button;
                }
            }
        });

        if (bestButton) {
            const input = bestButton.querySelector('input');
            console.log(`Target weight: ${targetWeight}lbs, Selected range: ${input.dataset.start}-${input.dataset.end}lbs, Score: ${bestScore}`);
        }

        return bestButton;
    }

    slideUp(duration = 500) {
        this.style.transitionProperty = 'height, margin, padding';
        this.style.transitionDuration = duration + 'ms';
        this.style.boxSizing = 'border-box';
        this.style.height = this.offsetHeight + 'px';
        this.offsetHeight;
        this.style.overflow = 'hidden';
        this.style.height = 0;
        this.style.paddingTop = 0;
        this.style.paddingBottom = 0;
        this.style.marginTop = 0;
        this.style.marginBottom = 0;
        window.setTimeout(() => {
            this.style.display = 'none';
            this.style.removeProperty('height');
            this.style.removeProperty('padding-top');
            this.style.removeProperty('padding-bottom');
            this.style.removeProperty('margin-top');
            this.style.removeProperty('margin-bottom');
            this.style.removeProperty('overflow');
            this.style.removeProperty('transition-duration');
            this.style.removeProperty('transition-property');
            //alert("!");
        }, duration);
    }

    /* SLIDE DOWN */
    slideDown(duration = 500) {
        this.style.removeProperty('display');
        let display = window.getComputedStyle(this).display;
        if (display === 'none') display = 'flex';
        this.style.display = display;
        let height = this.offsetHeight;
        this.style.overflow = 'hidden';
        this.style.height = 0;
        this.style.paddingTop = 0;
        this.style.paddingBottom = 0;
        this.style.marginTop = 0;
        this.style.marginBottom = 0;
        this.offsetHeight;
        this.style.boxSizing = 'border-box';
        this.style.transitionProperty = 'height, margin, padding';
        this.style.transitionDuration = duration + 'ms';
        this.style.height = height + 'px';
        this.style.removeProperty('padding-top');
        this.style.removeProperty('padding-bottom');
        this.style.removeProperty('margin-top');
        this.style.removeProperty('margin-bottom');
        window.setTimeout(() => {
            this.style.removeProperty('height');
            this.style.removeProperty('overflow');
            this.style.removeProperty('transition-duration');
            this.style.removeProperty('transition-property');
        }, duration);
    }
}

customElements.define('product-custom-siblings', ProductCustomSiblings);